var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterpass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 78.57 50",
    width: 78.57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a {\n            fill: #f37f39;\n        }\n\n        .b {\n            fill: #f0b050;\n        }\n\n        .c {\n            fill: #e34538;\n        }\n\n        .d {\n            clip-path: url(#a);\n        }"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1329 -419)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1329 419)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    transform: "translate(28.571 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1329 419)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    transform: "translate(28.572)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterpass);
export default __webpack_public_path__ + "static/media/masterpass.cd828092e12a2a4ad3ba693e7e33c509.svg";
export { ForwardRef as ReactComponent };